export { retrieveSelectedChartData } from './chartsService';
export { retrieveLabelsForChart, createNewLabel, editEventLabel, deleteEventLabel } from './labelsService';
export { updateChartForToggledSarcasticCommentOrTweet } from './updateChartForToggledSarcasticCommentOrTweetService';
export { updateChartForRelevanceUpdatesOfCommentOrTweet } from './updateChartForRelevanceUpdatesOfCommentOrTweetService';
export { updateChartForRelevanceUpdatesOfPost } from './updateChartForRelevanceUpdatesOfPostService';


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/actions.js